"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 14';

var Comment = function Comment() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "m12.25 0.475h-10.5a1.75 1.75 0 0 0-1.75 1.75v6.883l8e-3 0.169a1.75 1.75 0 0 0 1.742 1.581h1.652l2.04 2.665 2.209-2.666 4.599 1e-3a1.75 1.75 0 0 0 1.75-1.75v-6.883a1.75 1.75 0 0 0-1.75-1.75zm-10.5 1.167h10.5c0.322 0 0.583 0.26 0.583 0.583v6.883a0.583 0.583 0 0 1-0.583 0.584h-5.148l-1.626 1.958-1.498-1.958h-2.228a0.583 0.583 0 0 1-0.583-0.584v-6.883c0-0.322 0.26-0.583 0.583-0.583z"
  }), _react["default"].createElement("path", {
    d: "m10.368 4.85c0.39852-0.0044 0.71833-0.33047 0.715-0.729 0-0.402-0.32-0.73-0.715-0.73h-6.736c-0.39892 0.0044-0.71889 0.33108-0.715 0.73 0 0.402 0.32 0.729 0.715 0.729z"
  }), _react["default"].createElement("path", {
    d: "m9.303 7.767c0.339 0 0.614-0.327 0.614-0.73 0-0.402-0.275-0.729-0.614-0.729h-5.773c-0.339 0-0.613 0.327-0.613 0.73 0 0.402 0.274 0.729 0.613 0.729z"
  }));
};

var _default = (0, _createSvgIcon["default"])(Comment, {
  viewBox: viewBox
});

exports["default"] = _default;